import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoaderService } from '@services/loader.service';
import { PlacementService } from '@services/placement.service';
import { VaccineService } from '@services/vaccine.service';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-active-vaccines-program',
    templateUrl: './active-vaccines-program.component.html',
    styleUrl: './active-vaccines-program.component.scss'
})
export class ActiveVaccinesProgramComponent implements OnInit {
    @Input() placementId: number | null = null;
    @Output() close: EventEmitter<void> = new EventEmitter<void>();
    brands: any[] = [];
    chickstypes: any[] = [];
    houses: any[] = [];
    vaccinationForm: FormGroup;
    public isAuthLoading = false;
    public isLoading$: Observable<boolean>;
    @Output() dataSaved: EventEmitter<void> = new EventEmitter<void>();

    constructor(
        private fb: FormBuilder,
        private vaccineService: VaccineService,
        private placementService: PlacementService,
        private toastr: ToastrService,
        private loaderService: LoaderService
    ) { }

    ngOnInit(): void {
        this.vaccinationForm = this.fb.group({
            vaccines: this.fb.array([this.createVaccineGroup()])
        });
        this.getBrandList();
        this.getChicksTypeList();
        this.getHouseList();
    }

    // Create form group for each vaccine entry
    createVaccineGroup(): FormGroup {
        return this.fb.group({
            id: [0],
            placementId: [this.placementId], // Set placementId statically or dynamically
            brandId: ['', Validators.required], // Stores brandId
            chicksTypeId: ['', Validators.required], // Stores chicksTypeId
            quantity: [0, Validators.required],
            houseIds: [[], Validators.required],
            houseVaccinations: this.fb.array([]),
            notes: '',
            applicationDate: ['', Validators.required]
        });
    }

    // Getter for vaccines FormArray
    get vaccines(): FormArray {
        return this.vaccinationForm.get('vaccines') as FormArray;
    }

    // Add new vaccine entry
    addVaccine(): void {
        this.vaccines.push(this.createVaccineGroup());
    }

    getBrandList() {
        this.vaccineService.getMainVaccinationList().subscribe((result) => {
            //console.log(result);
            this.brands = result;
        });
    }

    getChicksTypeList() {
        this.placementService.getChicksTypeList().subscribe((result) => {
            // console.log(result);
            this.chickstypes = result;
        });
    }
    getHouseList() {
        this.placementService.getActiveBirdCount(this.placementId || 0)
            .subscribe((result) => {
                this.houses = result;
            });
    }

     // House Vaccination FormArray
    getHouseVaccinations(index: number): FormArray {

        return this.vaccines
            .at(index)
            .get('houseVaccinations') as FormArray;
    }
    
    // House Selection Change
    onHouseSelectionChange(
        event: any,
        index: number
    ): void {

        const vaccineGroup =
            this.vaccines.at(index);

        const selectedHouseIds =
            event.value || [];

        vaccineGroup.patchValue({
            houseIds: selectedHouseIds
        });

        vaccineGroup
            .get('houseIds')
            ?.markAsTouched();

        const houseVaccinations =
            vaccineGroup.get(
                'houseVaccinations'
            ) as FormArray;

        // Clear Existing Rows
        houseVaccinations.clear();

        if (selectedHouseIds.length === 0) {
            return;
        }

        // Add Dynamic Rows
        selectedHouseIds.forEach(
            (houseId: number) => {

                const selectedHouse =
                    this.houses.find(
                        (x: any) =>
                            x.houseId === houseId
                    );

                if (selectedHouse) {

                    houseVaccinations.push(

                        this.fb.group({

                            houseId: [
                                selectedHouse.houseId
                            ],

                            houseName: [
                                {
                                    value:
                                        selectedHouse.houseName,
                                    disabled: true
                                }
                            ],

                            birdsVaccinated: [
                                selectedHouse.activeBirdCount,
                                Validators.required
                            ]
                        })
                    );
                }
            }
        );
    }
    // Handle form submission
    onSave(): void {
        this.loaderService.showLoader();
        this.isAuthLoading = true;
        if (this.vaccinationForm.valid) {
            const formValue = this.vaccinationForm.value;
            const vaccinesData = formValue.vaccines.map((vac: any) => ({
                ...vac,
                applicationDate: vac.applicationDate
                    ? new Date(vac.applicationDate).toISOString()
                    : null
            }));
            this.placementService
                .addActivePlacementVaccines(vaccinesData)
                .subscribe({
                    next: (response) => {
                        setTimeout(() => {
                            this.isAuthLoading = false;
                            this.loaderService.hideLoader();
                            this.toastr.success('Vaccine Added Successfully');
                            this.dataSaved.emit();
                            this.close.emit();
                        }, 2000);
                    },
                    error: (error) => {
                        setTimeout(() => {
                            this.isAuthLoading = false;
                            this.loaderService.hideLoader();
                            this.toastr.error('Vaccine Not Added');
                        }, 2000);
                    }
                });
        } else {
            this.vaccinationForm.markAllAsTouched();
            this.isAuthLoading = false;
            this.loaderService.hideLoader();
        }
    }
    removeWeightField(index: number): void {
        if (this.vaccines.length > 1) {
            this.vaccines.removeAt(index);
        }
    }

    removeVaccine(index: number): void {
        this.vaccines.removeAt(index);
    }
}
